export default "__VITE_ASSET__ab0019ef__"